import React, { useEffect, useRef } from "react";
import './AboutUs.css';
import Navbar from "../Navbar/Navbar";

// about page images
import DNA from './AboutImages/Dna.png';
import GirlTesting from './AboutImages/girltesting.png';
import Magnifyingglass from './AboutImages/magnifyingglass.png';
import RoundTube from './AboutImages/roundtube.png';
import TestTube from './AboutImages/testtube.png';
import Heartbeat from './AboutImages/heartbeat.png';
import Medicalshield from './AboutImages/medicalshield.png';
import Bluepill from './AboutImages/bluepill.png';
import Flaskchemical from './AboutImages/flaskchemical.png';
import Medicalpills from './AboutImages/medicalpills.png';
import Openyellowpill from './AboutImages/Openyellowbottle.png';
import Lankarao from './AboutImages/Lankarao.png';
import Venkateswararao from './AboutImages/venkateswararao.png';
import Srinivasabkkumal from './AboutImages/srinivasabkkumalla.png';
import Bnsraju from './AboutImages/bnsraju.png';
import Jayakrishna from './AboutImages/jayakrishna.png';
import Gayatriswaroop from './AboutImages/gayatriswaroop.png';



import OurVision from "./AboutInner/OurVision";
import OurValues from "./AboutInner/OurValues";
import Footer from "../Footer/Footer";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from "react-router-dom";

function AboutUs(){
    const navigate = useNavigate();
    const renderOnlyOnce = useRef(false);
    useEffect(()=>{
        if(!renderOnlyOnce.current){
            window.scrollTo({behavior:'instant',top:0});
            renderOnlyOnce.current=true;
        }
    },[]);
    return(
        <>
            <div className="aboutus-container">
                <Navbar/>
                <div className="aboutus-con-one">
                    {/* main contents */}
                    <div className="aboutus-c1-i">
                        <div className="aboutus-c1-i-main">
                            <div className="aboutus-c1-i-main-paras">
                                <p className="aboutus-c1-i-main-para1">committed to your</p>
                                <p className="aboutus-c1-i-main-para2"><span>health</span>, every step</p>
                                <p className="aboutus-c1-i-main-para3">Bringing quality care and trust to our community, one patient at a time.</p>
                            </div>
                            {/* home two providing safty and support */}
                            <div className="aboutus-providingsafty">
                                <div className="aboutus-providingsafty-img">
                                    <img src={Medicalshield} alt='medicalshield'/>
                                </div>
                                <div className="aboutus-providingsafty-con">
                                    <h2>Providing Safety</h2>
                                    <p>At Arde’s, we prioritize safety by ensuring all medications meet rigorous quality standards, fostering trust in every health journey.</p>
                                </div>
                            </div>

                            <div className="aboutus-caresupport">
                                <div className="aboutus-caresupport-img">
                                    <img src={Heartbeat} alt='heartbeat'/>
                                </div>
                                <div className="aboutus-caresupport-content">
                                    <h2>Personalized care and support</h2>
                                    <p>At Arde’s, we prioritize each customer’s unique health needs, offering personalized care and attentive support. Our goal is to provide guidance that fosters trust and enhances well-being.</p>
                                </div>
                            </div>
                        </div>
                        <div className="aboutus-c1-ii">
                            <img src={DNA} alt='temp' className="aboutus-c1-ii-img1"/>
                            <img src={TestTube} alt='testtube' className="aboutus-c1-ii-img2"/>
                            <img src={RoundTube} alt='roundtube' className="aboutus-c1-ii-img3"/>
                            <img src={Magnifyingglass} alt="magnifying glasses" className="aboutus-c1-ii-img4"/>
                            {/* <div >
                                
                            </div> */}
                            <div className="aboutus-c1-ii-img">
                                <img src={GirlTesting} alt='girltesting'/>
                            </div>
                            <div className="aboutus-c1-ii-bottom"></div>
                        </div>
                    </div>
                    {/* blur boxes */}
                    <div className="aboutus-square-box1">
                    </div>
                    <div className="aboutus-square-box2">
                    </div>
                </div>

                {/* our misssion */}
                <div className="aboutus-ourmission-con">

                    <div className="aboutus-ourmission">
                        <div className="aboutus-ourmission-one">
                            <div className="aboutus-ourmission-one-img">
                                <img src={Bluepill} alt='bluepill' />
                            </div>
                            <div className="aboutus-ourmission-one-1">
                                <h2>our mission</h2>
                                <h3>Providing safe, accessible, and dependable healthcare solutions to support wellness across the globe.</h3>
                                <p>
                                    To lead globally in pharmaceuticals by delivering affordable, high-quality medicines that meet worldwide needs. Our vision is a strong global presence, providing accessible, cost-effective healthcare solutions with uncompromising quality and innovation.
                                </p>
                            </div>
                        </div>
                        <div className="aboutus-ourmission-two">
                            <div className="aboutus-ourmission-two-squarebox"></div>
                            <div className="aboutus-ourmission-two-img1">
                                <img src={Flaskchemical} alt='chemialflask'/>
                            </div>
                            <div className="aboutus-ourmission-two-img2">
                                <img src={Medicalpills} alt='mediaclpills'/>
                            </div>
                            <div className="aboutus-ourmission-two-img3">
                                <img src={Medicalpills} alt='mediaclpills'/>
                            </div>
                            {/* main image */}
                            <div className="aboutus-ourmission-two-mainimg">
                                <img src={Openyellowpill} alt='open yellow pill' />
                            </div>
                        </div>
                    </div>

                    {/* background blur boxes */}
                    <div className="aboutus-ourmission-blur-box1"></div>
                    <div className="aboutus-ourmission-blur-box2"></div>
                </div>
                {/* our vision */}
                <OurVision/>
                {/* our values */}
                <OurValues/>

                {/* team meet */}
                <div className="about-teammate-con">
                    <div className="about-teammate-header">
                        <h2>Meet the <span>Team</span> Behind the Mission</h2>
                        <p>We are the people who make up a dedicated team, driven to deliver impactful healthcare solutions with excellence and care.</p>
                    </div>
                    <div className="about-teammate-inner">
                        <div className="about-teammates-each">
                            <div className="about-teammates-each-img">
                                <img src={Lankarao} alt='teammates'/>
                            </div>
                            <div className="about-teammatesnames">
                                <h2>Lanka Rao Konda</h2>
                                <p>Director Business Operations</p>
                            </div>
                        </div>
                        <div className="about-teammates-each">
                            <div className="about-teammates-each-img">
                                <img src={Venkateswararao} alt='teammates'/>
                            </div>
                            <div className="about-teammatesnames">
                                <h2>Venkateswara Rao Patakota </h2>
                                <p>Director Financial Operations</p>
                            </div>
                        </div>
                        <div className="about-teammates-each">
                            <div className="about-teammates-each-img">
                                <img src={Srinivasabkkumal} alt='teammates'/>
                            </div>
                            <div className="about-teammatesnames">
                                <h2>Srinivasa Bikkumalla</h2>
                                <p>COO & Head Global BD and operations</p>
                            </div>
                        </div>
                        <div className="about-teammates-each">
                            <div className="about-teammates-each-img">
                                <img src={Bnsraju} alt='teammates'/>
                            </div>
                            <div className="about-teammatesnames">
                                <h2>Dr B.N.S Raju</h2>
                                <p>Director R&D Operations</p>
                            </div>
                        </div>
                        <div className="about-teammates-each">
                            <div className="about-teammates-each-img">
                                <img src={Jayakrishna} alt='teammates'/>
                            </div>
                            <div className="about-teammatesnames">
                                <h2>Jaya Krishna.Varada</h2>
                                <p>Head Chemical Synthesis</p>
                            </div>
                        </div>
                        <div className="about-teammates-each">
                            <div className="about-teammates-each-img">
                                <img src={Gayatriswaroop} alt='teammates'/>
                            </div>
                            <div className="about-teammatesnames">
                                <h2>Dr M. Gayatri Swaroop</h2>
                                <p>Head Discovery Synthesis</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* extra contact page navigating */}
                <div className="aboutus-extra-contentdiv">
                    <div className="aboutus-extra-contentdiv-inner">

                        <div className="aboutus-extra-contentdiv-msgbox">
                            <h2>We’re just a message away from supporting your health journey.</h2>
                        </div>
                        <div className="aboutus-extra-contentdiv-msgboxpara">
                            <p>Whether you have questions, need guidance, or are looking for tailored health solutions, our team is here to help. Reach out, and let’s take the next step in your wellness journey together.</p>
                        </div>
                        <div className="aboutus-extra-contentdiv-arrow">
                            <div className="aboutus-extra-contentdiv-arrow-inner" onClick={()=>navigate('/contactus')}>
                                <p>Contact us</p>
                                <div>
                                    <ArrowForwardIcon sx={{fontSize:22}}/>
                                </div>
                            </div>
                        </div>
                        <div className="aboutus-extra-contentdiv-blur1"></div>
                        <div className="aboutus-extra-contentdiv-blur2"></div>
                    </div>
                </div>
                {/* footer */}
                <Footer/>
            </div>
        </>
    );
}

export default AboutUs;